import { render, staticRenderFns } from "./reportAssistant.vue?vue&type=template&id=edce332e&scoped=true&"
import script from "./reportAssistant.vue?vue&type=script&lang=js&"
export * from "./reportAssistant.vue?vue&type=script&lang=js&"
import style0 from "./reportAssistant.vue?vue&type=style&index=0&id=edce332e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edce332e",
  null
  
)

export default component.exports